import { useState, useEffect } from 'react'
import { supabase } from '@/lib/supabase'

interface MaintenanceStatus {
  enabled: boolean
  endTime: string | null
  loading: boolean
}

export function useMaintenanceMode(): MaintenanceStatus {
  const [enabled, setEnabled] = useState(false)
  const [endTime, setEndTime] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let mounted = true

    const fetchStatus = async () => {
      const { data, error } = await supabase.rpc('get_maintenance_status')
      if (!mounted) return
      if (!error && data && data.length > 0) {
        setEnabled(data[0].enabled ?? false)
        const et = data[0].end_time
        if (et && new Date(et) > new Date()) {
          setEndTime(et)
        } else {
          setEndTime(null)
        }
      }
      setLoading(false)
    }

    fetchStatus()

    return () => {
      mounted = false
    }
  }, [])

  return { enabled, endTime, loading }
}
